import { useEffect, useState } from 'react'
import { getAccessToken } from 'services/Authentication'

/**
 * Fetches the clinic's doctors once and exposes a map of
 * account id -> doctor last name, matching the pattern used in the
 * patients list (lock "viewed by Dr. X" tooltip).
 *
 * Note: `ListAccounts?role=doctor` is scoped to the current clinic, so
 * an id sent by a doctor outside that scope may not resolve. Callers
 * should handle a missing entry gracefully.
 */
const useDoctorMap = (): Map<number, string> => {
  const [doctorMap, setDoctorMap] = useState<Map<number, string>>(new Map())

  useEffect(() => {
    const token = getAccessToken()
    const baseUrl = process.env.REACT_APP_GLOBAL_SERVICE_URL || ''
    fetch(`${baseUrl}/ListAccounts?role=doctor`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then(r => r.json())
      .then((data: any) => {
        const map = new Map<number, string>()
        const list = Array.isArray(data) ? data : data?.accounts ? data.accounts : []
        list.forEach((acc: any) => {
          if (acc?.id && acc?.last_name) {
            map.set(acc.id, acc.last_name)
          }
        })
        setDoctorMap(map)
      })
      .catch(() => {})
  }, [])

  return doctorMap
}

export default useDoctorMap
